import clientLogo from "../../images/clients/Colored/4099929_md.jpg"

const centricEvents = {
  pageTitle: "Visiomate - Centric Events Case Study",
  metaDescription:
    "Visiomate connected lead intake, projects, contracts and profitability on Odoo for Centric Events & Rentals, protecting margins while events are still running.",
  clientName: "Centric Events",
  bannerSummary: "One connected system from first enquiry to final invoice for a Phoenix live events company",
  introHeading: "Integrated Lifecycle and Financial Intelligence for Centric Events",
  heroImageAlt: "Event production control desk",
  clientLogoSrc: clientLogo,
  about:
    "Centric Events & Rentals is a full-service live event production company based in Phoenix. From corporate conferences and concerts to luxury weddings and brand activations, it combines audio, lighting and video production with premium event rentals. Visiomate connected its sales, projects, contracts and finances on Odoo.",

  challengesIntro: "Every event passed through several disconnected steps, and margin was lost between them.",
  challenges: [
    {
      title: "Lead Leakage",
      desc: "Enquiries arrived through the website, phone, referrals and ads, with no single place to track them.",
    },
    {
      title: "Re-keyed Data",
      desc: "Details were typed again between the CRM and projects, so errors crept in.",
    },
    {
      title: "Manual Contracts",
      desc: "Contracts were prepared by hand, which risked mismatches with approved sales orders.",
    },
    {
      title: "Margin Erosion",
      desc: "Hidden costs, like sub-rentals, cut into profit before anyone noticed.",
    },
  ],

  solutionsIntro: "One workflow runs from the first enquiry through the event to the final invoice.",
  solutions: [
    {
      num: "01",
      text: "Unified Lead Intake",
      desc: "Website forms, Dialpad calls and other sources land in one CRM, with the salesperson assigned automatically.",
    },
    {
      num: "02",
      text: "One-Click Projects",
      desc: "Confirming a sales order creates the project, with tasks generated from templates for conferences, concerts, weddings, rentals and special events.",
    },
    {
      num: "03",
      text: "Contract Engine",
      desc: "Contracts generate straight from the sales order using client templates, with the products and services filled in.",
    },
    {
      num: "04",
      text: "Communication History",
      desc: "Emails, calls and texts log automatically against each lead, company and contact.",
    },
    {
      num: "05",
      text: "Margin Alerts and Change Orders",
      desc: "Real-time alerts flag \"margin killers\" such as sub-rentals, and every change order is tracked, approved and billed.",
    },
    {
      num: "06",
      text: "Tiered Dashboards",
      desc: "Project managers and executives see live profitability and KPIs instead of guesswork.",
    },
  ],

  resultsIntro: "Centric Events now sees margin while the job is still running, not after the invoice.",
  metrics: [
    { metric: "100%", label: "Of change orders tracked, approved and billed" },
    { metric: "50%", label: "Margin target, protected by real-time \"margin killer\" alerts" },
    { metric: "100%", label: "Of data entered once, with no manual re-entry from lead to final invoice" },
  ],
  outcomes: [
    "Every lead is tracked from first contact to final invoice",
    "Every event follows the same standard process and audit, every time",
    "Leadership decides on live KPIs instead of guesswork",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/ecoZohm",
      label: "See the EcoZohm manufacturing story",
      note: "Odoo ERP for a sustainable LED lighting manufacturer, live in seven weeks.",
    },
    {
      to: "/caseStudies/projects/netAtlantic",
      label: "Read the Net Atlantic story",
      note: "A rebuilt email marketing platform, 35% faster campaign deployment.",
    },
  ],
}

export default centricEvents
